<div class="dialog-header-container">
    <h2 class="header-container" mat-dialog-title style="padding-top: 5px !important;">{{meetingInfoData.tableResponse.meetingTitle}}</h2>
    <div>
        <button mat-icon-button mat-dialog-close aria-label="Example icon-button with heart icon" #tooltip="matTooltip"
        matTooltip="close dialog">
            <mat-icon class = "dialog-close-btn" >close</mat-icon>
        </button>
    </div>
</div>
<ng-scrollbar #scrollable pointerEventsMethod="scrollbar">
<mat-dialog-content class="main-container">
    <div class="content-container">
    
        <div class="sub-header-container">
            <div class="left-sub-header-container">
                <h3 class="dlog-date-container body-font-size">
                    {{meetingInfoData.tableResponse.meetingDateFullFormat}} at {{meetingInfoData.tableResponse.meetingStartTime}} PM for {{meetingInfoData.tableResponse.meetingStartTime.duration}} Minutes
                </h3>
            </div>
            <!-- <div class="right-sub-header-container">
                <button mat-raised-button class="start"><p class="vert-icon-p-tag">START</p></button>
            </div> -->
        </div>
        <div>
            <ul class="un-order-list-container">
                <li *ngFor = "let attendeeName of meetingInfoData.tableResponse.attendeeList" class = "list-item body-font-size">
                    {{attendeeName.attendeeName}}
                </li>
                <!-- <li class = "list-item">
                    ShivaKumar M
                </li>
                <li class = "list-item">
                    Chandrasekar K
                </li> -->
                <!-- <li class = "list-item">
                    3 More ...
                </li> -->
            </ul>
        </div>
        <mat-divider></mat-divider>
        <div>
            <cdk-accordion class="example-accordion" multi = "true">
                <cdk-accordion-item
                  expanded = "true"
                  *ngFor="let item of meetingInfoData.tableResponse.agendaList; let index = index;"
                  #accordionItem="cdkAccordionItem"
                  class="example-accordion-item"
                  role="button"
                  tabindex="0"
                  [attr.id]="'accordion-header-' + index"
                  [attr.aria-expanded]="accordionItem.expanded"
                  [attr.aria-controls]="'accordion-body-' + index"
                  >
                  <div class="example-accordion-item-header d-flex align-items-center" (click)="accordionItem.toggle()">
                    <!-- <p>One</p> -->
                    <button mat-icon-button class="example-accordion-item-description">
                        <mat-icon>{{ accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                    </button>
                    <div>
                        <h3 class="margin-0 body-font-size f-weight">{{item.agendaTitle}}</h3>
                    </div>
                    <!-- </span> -->
                  </div>
                  <div
                    class="example-accordion-item-body"
                    role="region"
                    [style.display]="accordionItem.expanded ? '' : 'none'"
                    >
                    <ng-container *ngFor="let agendaItems of item.minutesList;let minIndex = index;">
                        <!-- Note starts -->
                        <ng-container *ngIf="agendaItems.entityType=='MN'">
                            <app-instant-meeting-note [minAttrList]="agendaItems" [hideParts] = "true"></app-instant-meeting-note>
                        </ng-container>
                        <!-- Note ends -->
                        <!-- For decision starts -->
                        <ng-container *ngIf="agendaItems.entityType=='MD'">
                            <app-instant-meeting-decision [minAttrList]="agendaItems" [hideParts] = "true"></app-instant-meeting-decision>
                        </ng-container>
                        <!-- decision ends -->
                        <!-- Task starts -->
                        <ng-container *ngIf="agendaItems.entityType=='AI'">
                            <app-instant-meeting-task [minAttrList]="agendaItems" [hideParts] = "true"></app-instant-meeting-task>
                        </ng-container>
                        <!-- Task Ends -->
                       
                    </ng-container>
                    <div *ngIf = "item.minutesList.length == 0">
                        <h3 class="margin-0 body-font-size" style="margin-left: 45px !important;"></h3>
                    </div>
                  </div>
                </cdk-accordion-item>
            </cdk-accordion>
        </div>

    </div>
</mat-dialog-content>
</ng-scrollbar>
